/**
 * Pure, React/DOM/Redux-free presentational formatters shared between the live viz UI and a future
 * server-side (SSR) chart-render sidecar. These MUST stay dependency-free (no imports) so the pure
 * echarts option builders in this directory can bundle into Node with a single esbuild step.
 *
 * `Utils.tsx` re-exports these two so existing UI importers are unaffected; keep the canonical
 * definitions HERE (Utils.tsx also carries DOM-coupled helpers like `downloadJSON`, which is exactly
 * why the option builders must not import from it).
 */

/** Compact numeric tick label used across the viz charts (e.g. 30000 -> "30k", 2_000_000 -> "2mil"). */
export const visTickFormatter = (value: number): string => {
  if (value >= 1_000_000) return `${value / 1_000_000}mil`
  if (value >= 1_000) return `${value / 1_000}k`
  return '' + value
}

/** Escape a string for safe interpolation into echarts tooltip HTML (formatter return strings). */
export const escapeHtml = (s: string): string => s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`)
